var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/PensionPaymentConstants.js');

var ActionTypes = Constants.ActionTypes;

module.exports = {
    updatePensionPaymentModel: function (fieldId, value, componentId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_PENSION_PAYMENT_MODEL,
            fieldId: fieldId,
            value: value,
            componentId: componentId
        });
    },
    updateInvestmentOption: function (index, value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_PENSION_PAYMENT_INVESTMENT_OPTION,
            index: index,
            value: value
        });
    },
    setPensionAllocationSameAsInvestmentAllocation: function (option) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_PENSION_ALLOCATION_SAME_AS_INV_ALLOCATION,
            option:option
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/PensionPaymentActions.js